module.exports = __webpack_public_path__ + "static/media/quizzes-icon.71c5255b.svg";